import { Money, formatMoney } from '@betterment/core';
import { Box, H6, Separator, Text, ToggleTip } from '@betterment/samba-react';

type NetDepositsProps = {
  netDeposits: Money;
  deposits: Money;
  pendingDeposits?: Money;
  withdrawals: Money;
  pendingWithdrawals?: Money;
};

const toggleTipMsg = `Transfers between Betterment accounts appear as a withdrawal from the source account and a deposit into the destination account.`;

export const NetDeposits: React.FC<NetDepositsProps> = ({
  netDeposits,
  deposits,
  pendingDeposits,
  withdrawals,
  pendingWithdrawals,
}) => (
  <Box>
    <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box css={{ display: 'grid' }}>
        <Box css={{ display: 'flex' }}>
          <H6 variant="title100" css={{ fontWeight: 'normal' }}>
            Net Deposits
          </H6>
          <ToggleTip>
            <ToggleTip.Trigger iconName="InfoCircle" label="Toggle Tip" />
            <ToggleTip.Content side="right" css={{ maxWidth: '300px' }}>
              {toggleTipMsg}
            </ToggleTip.Content>
          </ToggleTip>
        </Box>
      </Box>
      <Box>
        <Text>{formatMoney(netDeposits)}</Text>
      </Box>
    </Box>
    <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box>
        <Text color="text.weak">Deposits</Text>
      </Box>
      <Box>
        <Text color="text.weak">{formatMoney(deposits)}</Text>
      </Box>
    </Box>
    {pendingDeposits && pendingDeposits.cents !== 0 && (
      <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <Text color="text.weak">Pending deposits</Text>
        </Box>
        <Box>
          <Text color="text.weak">{formatMoney(pendingDeposits)}</Text>
        </Box>
      </Box>
    )}
    <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box>
        <Text color="text.weak">Withdrawals</Text>
      </Box>
      <Box>
        <Text color="text.weak">{formatMoney(withdrawals)}</Text>
      </Box>
    </Box>
    {pendingWithdrawals && pendingWithdrawals.cents !== 0 && (
      <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <Text color="text.weak">Pending withdrawals</Text>
        </Box>
        <Box>
          <Text color="text.weak">{formatMoney(pendingWithdrawals)}</Text>
        </Box>
      </Box>
    )}
    <Separator css={{ mt: 'space.400' }} />
  </Box>
);
